
import { computed, defineComponent, ref } from 'vue'
import RandselDialog from '@/components/Abstract/RandselDialog.vue'
import NameColorForm from '@/components/Abstract/NameColorForm.vue'
import NameCharForm from '@/components/Abstract/NameCharForm.vue'
import nameSettings from '@/settings/name-settings.json'
import { ConfigurationActionTypes } from '@/store/modules/configuration/action-types'
import Analytics from '@/singletons/analytics'
import { useStore } from '@/store'

export default defineComponent({
  name: 'MobileNameDialog',
  components: {
    RandselDialog,
    NameColorForm,
    NameCharForm
  },
  setup() {
    const store = useStore()
    const configNamethreadId = computed(() => store.getters.configNamethreadId)
    let root = ref<InstanceType<typeof RandselDialog>>()
    let colorForm = ref<InstanceType<typeof NameColorForm>>()
    let charForm = ref<InstanceType<typeof NameCharForm>>()
    let currentPage = ref(0)

    const onRemoveClick = () => {
      store.dispatch(ConfigurationActionTypes.SET_CONFIG_NONAME, nameSettings.noName.id)
      store.dispatch(ConfigurationActionTypes.SET_CONFIG_NAEMTHREAD, null)
      store.dispatch(ConfigurationActionTypes.SET_CONFIG_NAMECHAR, null)
      Analytics.instance.sendNameYesNo(false)
      root.value?.hideDialog()
    }

    const onShow = () => {
      currentPage.value = 0
    }

    const onNext = () => {
      if (configNamethreadId.value == undefined || configNamethreadId.value == undefined) {
        return
      }
      currentPage.value = 1
    }

    const onSaveClick = () => {
      charForm.value?.onSubmit()
      if (!charForm.value?.isValid()) {
        return
      }
      root.value?.hideDialog()
    }

    return {
      nameSettings,
      root,
      currentPage,
      colorForm,
      charForm,
      onRemoveClick,
      onSaveClick,
      onShow,
      onNext,
      configNamethreadId
    }
  }
})
